import axios from '@/libs/api.request'
// 学生端简历信息表接口
const cvService = {
  // 一些不可变信息
  cvDetail (data) {
    return axios.request({
      url: '/ugd/info/detail',
      data,
      method: 'POST'
    })
  },
  // 基本信息-cn
  cvBaseInfoDetailCn (data) {
    return axios.request({
      url: '/ugd/info/basic/cn',
      data,
      method: 'POST'
    })
  },
  // 基本信息-en
  cvBaseInfoDetailEn (data) {
    return axios.request({
      url: '/ugd/info/basic/en',
      data,
      method: 'POST'
    })
  },
  // 基本信息-编辑-cn
  cvSaveBaseInfoCn (data) {
    return axios.request({
      url: '/ugd/info/modify/basic/cn',
      data,
      method: 'POST'
    })
  },
  // 基本信息-编辑-en
  cvSaveBaseInfoEn (data) {
    return axios.request({
      url: '/ugd/info/modify/basic/en',
      data,
      method: 'POST'
    })
  },
  // 家庭信息-cn
  cvFamilyDetailCn (data) {
    return axios.request({
      url: '/ugd/info/family/cn',
      data,
      method: 'POST'
    })
  },
  // 家庭信息-en
  cvFamilyDetailEn (data) {
    return axios.request({
      url: '/ugd/info/family/en',
      data,
      method: 'POST'
    })
  },
  // 家庭信息-编辑-cn
  cvSaveFamilyCn (data) {
    return axios.request({
      url: '/ugd/info/modify/family/cn',
      data,
      method: 'POST'
    })
  },
  // 家庭信息-编辑-en
  cvSaveFamilyEn (data) {
    return axios.request({
      url: '/ugd/info/modify/family/en',
      data,
      method: 'POST'
    })
  },
  // 教育背景-cn
  cvEducationDetailCn (data) {
    return axios.request({
      url: '/ugd/info/education/cn',
      data,
      method: 'POST'
    })
  },
  // 教育背景-en
  cvEducationDetailEn (data) {
    return axios.request({
      url: '/ugd/info/education/en',
      data,
      method: 'POST'
    })
  },
  // 教育信息-编辑-cn
  cvSaveEducationCn (data) {
    return axios.request({
      url: '/ugd/info/modify/education/cn',
      data,
      method: 'POST'
    })
  },
  // 教育信息-编辑-en
  cvSaveEducationEn (data) {
    return axios.request({
      url: '/ugd/info/modify/education/en',
      data,
      method: 'POST'
    })
  },
  // 课程信息-cn
  cvCourseDetailCn (data) {
    return axios.request({
      url: '/ugd/info/course/cn',
      data,
      method: 'POST'
    })
  },

  // 课程信息-en
  cvCourseDetailEn (data) {
    return axios.request({
      url: '/ugd/info/course/en',
      data,
      method: 'POST'
    })
  },
  // 课程信息-编辑-cn
  cvSaveCourseCn (data) {
    return axios.request({
      url: '/ugd/info/modify/course/cn',
      data,
      method: 'POST'
    })
  },
  // 课程信息-编辑-en
  cvSaveCourseEn (data) {
    return axios.request({
      url: '/ugd/info/modify/course/en',
      data,
      method: 'POST'
    })
  },
  // 标准化考试成绩-cn
  cvScoreDetailCn (data) {
    return axios.request({
      url: '/ugd/info/score/cn',
      data,
      method: 'POST'
    })
  },
  // 标准化考试成绩-en
  cvScoreDetailEn (data) {
    return axios.request({
      url: '/ugd/info/score/en',
      data,
      method: 'POST'
    })
  },
  // 标准化考试成绩-编辑-cn
  cvSaveScoreCn (data) {
    return axios.request({
      url: '/ugd/info/modify/score/cn',
      data,
      method: 'POST'
    })
  },
  // 标准化考试成绩-编辑-en
  cvSaveScoreEn (data) {
    return axios.request({
      url: '/ugd/info/modify/score/en',
      data,
      method: 'POST'
    })
  },
  // 学分课程信息-cn
  cvCreditDetailCn (data) {
    return axios.request({
      url: '/ugd/info/credit/cn',
      data,
      method: 'POST'
    })
  },
  // 学分课程信息-en
  cvCreditDetailEn (data) {
    return axios.request({
      url: '/ugd/info/credit/en',
      data,
      method: 'POST'
    })
  },
  // 学分课程信息-编辑-cn
  cvSaveCreditCn (data) {
    return axios.request({
      url: '/ugd/info/modify/credit/cn',
      data,
      method: 'POST'
    })
  },
  // 学分课程信息-编辑-en
  cvSaveCreditEn (data) {
    return axios.request({
      url: '/ugd/info/modify/credit/en',
      data,
      method: 'POST'
    })
  },
  // 奖项-cn
  cvAwardsDetailCn (data) {
    return axios.request({
      url: '/ugd/info/awards/cn',
      data,
      method: 'POST'
    })
  },
  // 奖项-en
  cvAwardsDetailEn (data) {
    return axios.request({
      url: '/ugd/info/awards/en',
      data,
      method: 'POST'
    })
  },
  // 奖项-编辑-cn
  cvSaveAwardsCn (data) {
    return axios.request({
      url: '/ugd/info/modify/awards/cn',
      data,
      method: 'POST'
    })
  },
  // 奖项-编辑-en
  cvSaveAwardsEn (data) {
    return axios.request({
      url: '/ugd/info/modify/awards/en',
      data,
      method: 'POST'
    })
  },
  // 活动-cn
  cvActivityDetailCn (data) {
    return axios.request({
      url: '/ugd/info/active/cn',
      data,
      method: 'POST'
    })
  },
  // 活动-en
  cvActivityDetailEn (data) {
    return axios.request({
      url: '/ugd/info/active/en',
      data,
      method: 'POST'
    })
  },
  // 活动-编辑-cn
  cvSaveActivityCn (data) {
    return axios.request({
      url: '/ugd/info/modify/active/cn',
      data,
      method: 'POST'
    })
  },
  // 活动-编辑-en
  cvSaveActivityEn (data) {
    return axios.request({
      url: '/ugd/info/modify/active/en',
      data,
      method: 'POST'
    })
  },
  // 爱好与特长-cn
  cvHobbyDetailCn (data) {
    return axios.request({
      url: '/ugd/info/hobbies/cn',
      data,
      method: 'POST'
    })
  },
  // 爱好与特长-en
  cvHobbyDetailEn (data) {
    return axios.request({
      url: '/ugd/info/hobbies/en',
      data,
      method: 'POST'
    })
  },
  // 爱好与特长-编辑-cn
  cvSaveHobbyCn (data) {
    return axios.request({
      url: '/ugd/info/modify/hobbies/cn',
      data,
      method: 'POST'
    })
  },
  // 爱好与特长-编辑-en
  cvSaveHobbyEn (data) {
    return axios.request({
      url: '/ugd/info/modify/hobbies/en',
      data,
      method: 'POST'
    })
  }
}

export default cvService
